import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setSession } from "../api";

export default function Login({ onLogin }) {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const r = await api.login(username.trim(), password);
      setSession(r);
      if (onLogin) onLogin(r.user);
      navigate("/bienvenida", { replace: true });
    } catch (e2) {
      setErr("Usuario o contraseña inválidos.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow p-6 border-t-4 border-worthgold">
        <h1 className="text-2xl font-extrabold text-worthblue mb-1">Worth Pagos</h1>
        <p className="text-sm text-gray-500 mb-6">Inicia sesión para continuar</p>

        {err && (
          <div className="mb-4 p-3 rounded bg-red-50 text-red-700 text-sm">{err}</div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm text-gray-600 mb-1">Usuario</label>
            <input
              className="w-full border rounded px-3 py-2"
              placeholder="admin"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          <div>
            <label className="block text-sm text-gray-600 mb-1">Contraseña</label>
            <input
              type="password"
              className="w-full border rounded px-3 py-2"
              placeholder="••••••••"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className={`w-full bg-worthblue text-white px-4 py-2 rounded font-semibold hover:bg-worthgold ${loading ? 'opacity-70 cursor-not-allowed' : ''}`}
          >
            {loading ? 'Entrando…' : 'Entrar'}
          </button>

          <p className="text-xs text-gray-500 text-center">
            * Usuario inicial: <b>admin</b>. La contraseña la defines con la variable <code>INIT_ADMIN_PASS</code>.
          </p>
        </form>
      </div>
    </div>
  );
}
